import axios from "axios";
import { createAsyncThunk } from "@reduxjs/toolkit";

const endPoint = process.env.REACT_APP_API_URL;

export const makeDeposit = createAsyncThunk(
  "make-deposit",
  async ({ owner, amount, pay_mode, payment_proof }, thunkApi) => {
    try {
      const form_data = new FormData();
      form_data.append("owner", owner);
      form_data.append("amount", amount);
      form_data.append("pay_mode", pay_mode);
      form_data.append("payment_proof", payment_proof);
      const config = {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      };
      const res = await axios.post(`${endPoint}/deposits/`, form_data, config);
      return res;
    } catch (error) {
      return thunkApi.rejectWithValue(error.response.data);
    }
  }
);
export const getDeposits = createAsyncThunk(
  "get-deposits",
  async ({ owner_id }, thunkApi) => {
    try {
      const config = {
        headers: {
          // 'Content-Type': 'application/json',
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      };
      const res = await axios.get(
        `${endPoint}/deposits/?owner=${owner_id}`,
        config
      );
      return res;
    } catch (error) {
      return thunkApi.rejectWithValue(error.response.data);
    }
  }
);
